import { arcService } from './arcService'
import { arcClaimService } from './arcClaimService'
import { arcReviewStatsService } from './arcReviewStatsService'

/**
 * The arc module façade.
 *
 * `ArcService` was 2,361 lines and 85 members, which is three services wearing one coat: the arc
 * lifecycle, claims, and reviews/stats. Those are now three files, split along the lanes its specs were
 * already written in.
 *
 * `service` composes all three so the 46 sites that injected `ArcService` keep the surface they had —
 * they call across the lanes freely, and re-homing every one of those calls is stage 8's job, when the
 * components are rewritten anyway. New code should import the narrow factory it needs
 * (`arcClaimService()` and friends) instead of reaching through here.
 *
 * The composed `globalLoader` has to be declared here rather than inherited from a spread: each of the
 * three returns *its own* bag for chaining, so `globalLoader(false).getClaims(...)` off a plain spread
 * would land on whichever bag was spread last and lose the other two.
 */

const composed = {
  ...arcService(),
  ...arcClaimService(),
  ...arcReviewStatsService(),

  globalLoader (enable: boolean) {
    arcService().globalLoader(enable)
    return composed
  }
}

export const useArc = () => {
  return {
    arc: {
      service: composed
    }
  }
}
